import { FormattedMessage } from 'react-intl';

import {
  CAREER_HUB_BASE_PATH,
  CareerHubBreadCrumb,
} from '@xing-com/crate-career-hub-common';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { TopBar } from '@xing-com/crate-layout-top-bar';
import { IconArrowLeft } from '@xing-com/icons';

import { Styled } from './header-navigation.styles';

export type HeaderNavigationType = {
  title: string;
};

export const HeaderNavigation: React.FC<HeaderNavigationType> = ({ title }) => {
  const { isLoggedOut } = useLoginState();

  return isLoggedOut ? (
    <CareerHubBreadCrumb />
  ) : (
    <>
      <TopBar type="subheader" {...{ title }} />
      <Styled.TextButton icon={IconArrowLeft} to={CAREER_HUB_BASE_PATH}>
        <FormattedMessage id="CAREER_HUB_BACK_BUTTON" />
      </Styled.TextButton>
    </>
  );
};
